import React, { Suspense } from 'react';

import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import store from './redux/store';

import './assets/icons/remixicon.css';
import './assets/less/yoda-theme.less';

import App from './App';

import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient();

ReactDOM.render(
  <Suspense fallback='loading'>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
          <ReactQueryDevtools />
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </Suspense>,
  document.getElementById('root'),
);
